import { decode } from './helpers/decode_env';

const authConfig = {
    authority: process.env.REACT_APP_AUTH_URL ? decode(process.env.REACT_APP_AUTH_URL): '',
    client_id: process.env.REACT_APP_IDENTITY_CLIENT_ID ? decode(process.env.REACT_APP_IDENTITY_CLIENT_ID): '',
    redirect_uri: process.env.REACT_APP_REDIRECT_URL ? decode(process.env.REACT_APP_REDIRECT_URL): '',
    response_type: 'code',
    scope: 'openid profile email offline_access',
    client_secret: process.env.REACT_APP_CLIENT_SECRET ? decode(process.env.REACT_APP_CLIENT_SECRET): '',
    response_mode: 'query',
    code_challenge_method: 'S256',
    post_logout_redirect_uri: process.env.REACT_APP_LOGOUT_REDIRECT_URL ? decode(process.env.REACT_APP_LOGOUT_REDIRECT_URL): '',
    // userStore: new WebStorageStateStore({store: window.sessionStorage})
  };

 export default authConfig;
